var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{'link-active': _vm.name === _vm.$route.name },on:{"click":function($event){return _vm.linkSelect({ name: _vm.name, params: {id: _vm.id} })}}},[_c('div',[_c('div',{staticClass:"icon_menu"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a7e08f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/detail/flap.vue
// module id = Sfli
// module chunks = 3